const START_KEY = (examId) => `exam_start_at_${examId}`
const ELAPSED_KEY = (examId) => `exam_elapsed_sec_${examId}`

/** 开始测评时记录起点（毫秒时间戳） */
export function recordExamStart(examId) {
  if (!examId) return
  const key = START_KEY(examId)
  if (!localStorage.getItem(key)) {
    localStorage.setItem(key, String(Date.now()))
  }
}

/** 当前已用秒数（从 recordExamStart 起算） */
export function getElapsedSeconds(examId) {
  const key = START_KEY(examId)
  const raw = localStorage.getItem(key)
  if (!raw) return 0
  const start = Number(raw)
  if (!start || Number.isNaN(start)) return 0
  return Math.max(0, Math.floor((Date.now() - start) / 1000))
}

/** 提交时固化用时，供登录认领页读取 */
export function stashElapsedSeconds(examId, seconds) {
  if (!examId) return
  localStorage.setItem(ELAPSED_KEY(examId), String(Math.max(0, Math.floor(seconds))))
}

/** 认领会话时优先读固化值，否则实时计算 */
export function resolveElapsedSeconds(examId) {
  const stashed = localStorage.getItem(ELAPSED_KEY(examId))
  if (stashed != null && stashed !== '') {
    const n = Number(stashed)
    if (!Number.isNaN(n) && n > 0) return Math.floor(n)
  }
  return getElapsedSeconds(examId)
}

export function clearExamTiming(examId) {
  if (!examId) return
  localStorage.removeItem(START_KEY(examId))
  localStorage.removeItem(ELAPSED_KEY(examId))
}
